import {useDispatch} from "react-redux";
import {openWindow} from "../../models/window/actions";
import {modalNames} from "../common/modal/constants/names";
import { useLayoutEffect, useRef } from 'react'
import gsap from 'gsap'

import c from "./assets/sass/headerMiddle.module.scss";

import cn from "classnames";

const HeaderMiddle = () => {
    const dispatch = useDispatch()
    const titleRef = useRef(null)
    const SplitText = window.SplitText;

    gsap.registerPlugin(SplitText)

    useLayoutEffect(() => {
        document.fonts.ready.then(() => {
            gsap.set(titleRef.current, {
                opacity: 1,
            })

            SplitText.create(titleRef.current, {
                type: 'words,lines',
                mask: 'lines',
                autoSplit: true,

                onSplit: (self) => {
                    return gsap.from(self.lines, {
                        yPercent: 100,
                        opacity: 0,
                        duration: 2,
                        stagger: 0.1,
                        delay: 2,
                        ease: 'expo.out',
                    })
                },
            })
        })
    }, [])

    const bookHandler = () => {
        dispatch(openWindow(modalNames.CONTACT_MODAL))
    }

    const scrollToPrice = (e) => {
        e.preventDefault()

        document.getElementById('price')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        })
    }

    return (
        <div className={c.middle}>
            <div className={c.title} ref={titleRef}>
                Студия Массажа и Коррекции <span>Фигуры</span>
            </div>
            <div className={c.subtitle}>
                Профессиональный ручной и аппаратный массаж
            </div>
            <div className={c.buttons}>
                <button
                    className={cn(c.middleButton, c.yellow)}
                    onClick={bookHandler}
                >
                    Записаться
                </button>
                <button
                    className={cn(c.middleButton, c.green)}
                    onClick={scrollToPrice}
                >
                    Услуги
                </button>
            </div>
        </div>
    )
}

export default HeaderMiddle
